import { Chip } from "@mui/material";
import { PromotionStatusValue } from "@quest_editor/constants";
import { getPromotionStatusOptions } from "@quest_editor/utils/view/constLabels";

type ChipColor =
  | "default"
  | "primary"
  | "secondary"
  | "error"
  | "info"
  | "success"
  | "warning";

const statusColorMap: Record<PromotionStatusValue, ChipColor> = {
  created: "success",
  request_waiting: "warning",
  waiting: "error",
  in_progress: "info",
  done: "default",
  suspended: "default",
  closed: "default",
};

const PromotionStatusChip = ({ status }: { status: PromotionStatusValue }) => {
  const promotionStatuses = getPromotionStatusOptions();
  const label =
    promotionStatuses.find((ps) => ps.value === status)?.label ?? status;
  const color = statusColorMap[status] || "default";

  return <Chip label={label} color={color} size="small" />;
};

export default PromotionStatusChip;
